import type { OfferInfo } from "@/utils/offerUtils";

export interface SubVariant {
  id?: string;
  colorHex?: string | null;
  poeticName?: string | null;
  poeticNameAr?: string | null;
  scent?: string | null;
  scentAr?: string | null;
  story?: string | null;
  storyAr?: string | null;
  priceDelta?: number;
  stockQuantity?: number;
  stockStatus?: string;
  imageUrl?: string | null;
  sortOrder?: number;
}

export interface SizeVariant {
  id?: string;
  size: string;
  label: string;
  labelAr: string;
  price: number;
  image: string;
  imageIsCustom?: boolean;
  packagingImage?: string;
  lifestyleImage?: string;
  ingredientsImage?: string;
  offer?: OfferInfo;
  stockQuantity?: number;
  stockStatus?: string;
  isFeatured?: boolean;
  poeticName?: string;
  poeticNameAr?: string;
  story?: string;
  storyAr?: string;
  colorHex?: string;
  subVariants?: SubVariant[];
}

export interface Product {
  id: string;
  name: string;
  nameAr: string;
  price: number;
  category: "soaps" | "toothpaste" | "lip-beauty" | "moroccan-black-soap" | "body-care" | "hair-care" | string;
  description: string;
  descriptionAr: string;
  shortDescription?: string;
  shortDescriptionAr?: string;
  /** Base size / volume when the product has no variants (e.g. "250 ml"). */
  size?: string;
  ingredients: string[];
  ingredientsAr: string[];
  benefits: string[];
  benefitsAr: string[];
  howToUse?: string;
  howToUseAr?: string;
  productDetails?: string[];
  productDetailsAr?: string[];
  features?: string[];
  featuresAr?: string[];
  image: string;
  packagingImage?: string;
  lifestyleImage?: string;
  ingredientsImage?: string;
  badge?: string;
  badgeAr?: string;
  offer?: OfferInfo;
  stockQuantity?: number;
  stockStatus?: string;
  flashDealEligible?: boolean;
  isFeatured?: boolean;
  sizeVariants?: SizeVariant[];
  essence?: {
    name: string;
    nameAr: string;
    description: string;
    descriptionAr: string;
    benefits: string[];
    benefitsAr: string[];
  };
  faqs?: ProductFaq[];
}

export interface ProductFaq {
  question: string;
  questionAr: string;
  answer: string;
  answerAr: string;
}


export const categories = [
  { id: "all", labelKey: "shop.all" },
  { id: "soaps", labelKey: "cat.soaps" },
  { id: "moroccan-black-soap", labelKey: "cat.moroccan-black-soap" },
  { id: "lip-beauty", labelKey: "cat.lip-beauty" },
  { id: "toothpaste", labelKey: "cat.toothpaste" },
  { id: "body-care", labelKey: "cat.body-care" },
  { id: "hair-care", labelKey: "cat.hair-care" },
] as const;

export const testimonials: {
  name: string;
  nameAr: string;
  location: string;
  locationAr: string;
  text: string;
  textAr: string;
}[] = [];
